import i18next from "i18next";

const KEY_PREFIX = "billing.";

export function localizeDescription(
  description: string | null | undefined,
): string {
  if (!description) return "";

  try {
    const parsed = JSON.parse(description);
    if (parsed.key && typeof parsed.key === "string") {
      const descKey = parsed.key.startsWith(KEY_PREFIX)
        ? parsed.key.slice(KEY_PREFIX.length)
        : parsed.key;
      return i18next.t(
        `Billing:Descriptions.${descKey}`,
        parsed.params ?? {},
      ) as string;
    }
  } catch {
    // Not JSON — return as-is (backward compatibility for plain-text descriptions)
  }

  return description;
}
